import { render, staticRenderFns } from "./ReportAccidentList.vue?vue&type=template&id=9b191c1e&scoped=true&"
import script from "./ReportAccidentList.vue?vue&type=script&lang=js&"
export * from "./ReportAccidentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b191c1e",
  null
  
)

export default component.exports